import { redirectToLogin } from "../annoucement-sheet";
import { api } from "../api";
import authHeader from "../auth-header";
export interface IVisionMissionInfo {
    "vision_mission": IVisionMission,
    "our_future": IOurFurture,
    "our_commitment": IOurCommitment
}
export interface IOurFurture {
    "id": number,
    "page_id": number,
    "section_order": number,
    "unique_name": string,
    "sub_title_en": string,
    "sub_title_tc": string,
    "sub_title_sc": string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "description_en": string,
    "description_tc": string,
    "description_sc": string,
    "image":string,
    "additional_data_en": null,
    "additional_data_tc": null,
    "additional_data_sc": null,
}
export interface IVisionMission {
    "id": number,
    "sub_menu_id": number,
    "menu_id": number,
    "slug": string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "meta_title_en": string,
    "meta_title_tc": string,
    "meta_title_sc": string,
    "meta_description_en": string,
    "meta_description_tc": string,
    "meta_description_sc": string,
    "meta_image": string,
    "banner_mobile_image": string,
    "banner_desktop_image": string,
    "is_slider": number,
}
export interface IOurCommitment {
    "id": number,
    "page_id": number,
    "section_order": number,
    "unique_name": string,
    "sub_title_en": string,
    "sub_title_tc": string,
    "sub_title_sc": string,
    "title_en": string,
    "title_tc": string,
    "title_sc": string,
    "description_en": string,
    "description_tc": string,
    "description_sc": string,
    "image": string,
    "additional_data_en": null,
    "additional_data_tc": null,
    "additional_data_sc": null,
}
export interface ICompanyHistory {

}
export type TData = {
    data: ICompanyHistory[];
    total: number;
};
export type PaginationData = {
    page: number;
    limit: number | string | undefined;
    search: string | number;
    sort?: string;
};
export const visionMissionApi = api.injectEndpoints({
    endpoints: (build) => ({
        getVisionMissionData: build.query<IVisionMissionInfo, void>({
            query: () => ({
                url: `fetch-vision-mission-page`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "CompanyHistory" as const, id: "LIST" }]
        }),
        getMissionList: build.query<TData, PaginationData>({
            query: ({ limit, page, search,sort }) => ({
                url: `our-commitment-content?per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
                headers: authHeader()
            }),
            keepUnusedDataFor: 0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: () => [{ type: "Mission" as const, id: "LIST" }]
        }),
        getMissionInfo: build.mutation<TData, PaginationData>({
            query({limit, page, search,sort}) {
                return {
                    headers: authHeader(),
                    url: `our-commitment-content?per_page=${limit}&page=${page}&search=${search}&sort=${sort}`,
                    method: "GET",
                };
            },
            invalidatesTags: ['Mission']
        }),
        deleteMission: build.mutation<TData, number>({
            query(body) {
              return {
                headers: authHeader(),
                url: `delete-our-commitment-content`,
                body: {
                  id: body
                },
                method: "POST",
              };
            },
            // invalidatesTags: ['Mission']
          }),
    })
});

export const { useGetVisionMissionDataQuery,useGetMissionListQuery ,useGetMissionInfoMutation,useDeleteMissionMutation} = visionMissionApi;

export const {
    endpoints: { getVisionMissionData,getMissionList,getMissionInfo,deleteMission }
} = visionMissionApi;
